export default [
	{
		path: '/agencies',
		name: 'agencies',
		component: () => import('@/views/Agency/Agencies.vue'),
		meta: { requiresAuth: true, permission: 'view_agencies' }
	},
	{
		path: '/agencies/create',
		name: 'agencies.create',
		component: () => import('@/views/Agency/CreateAgency.vue'),
		meta: { requiresAuth: true, permission: 'create_agency' }
	}
]
